import { useState, useCallback } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { Bell } from 'lucide-react'
import { pendenciaService } from '../../dominios/pendencias/services/pendencia'
import { ListaPendencias } from './ListaPendencias'
import { usePendenciasSocket } from '../../hooks/usePendenciasSocket'
import { PendenciaDto } from '../../dominios/pendencias/tipos/pendencia'
import { useUsuario } from '../../contexts/UsuarioContext'

const QUERY_KEY_PENDENCIAS_COUNT = ['pendencias', 'count']

export function BadgePendencias() {
  const [showLista, setShowLista] = useState(false)
  const { usuario } = useUsuario()
  const queryClient = useQueryClient()

  // Usar React Query para gerenciar o contador
  const { data: count = 0 } = useQuery(
    QUERY_KEY_PENDENCIAS_COUNT,
    async () => {
      try {
        return await pendenciaService.contarNaoLidas()
      } catch (error) {
        return 0
      }
    },
    {
      refetchOnWindowFocus: true,
      staleTime: 30000, // 30 segundos
      cacheTime: 60000 // 1 minuto
    }
  )

  // Callbacks estáveis para evitar recriação dos listeners
  const handlePendenciaRecebida = useCallback((pendencia: PendenciaDto, novoContador: number) => {
    // Atualizar contador diretamente com o valor do servidor
    if (pendencia.usuarioDestinoId === usuario?.id) {
      queryClient.setQueryData(QUERY_KEY_PENDENCIAS_COUNT, novoContador)
    }
  }, [usuario?.id, queryClient])

  const handlePendenciaAtualizada = useCallback((pendencia: PendenciaDto, novoContador: number) => {
    // Atualizar contador diretamente com o valor do servidor
    if (pendencia.usuarioDestinoId === usuario?.id) {
      queryClient.setQueryData(QUERY_KEY_PENDENCIAS_COUNT, novoContador)
    }
  }, [usuario?.id, queryClient])

  // Escutar eventos SignalR para atualizar contador em tempo real
  usePendenciasSocket({
    onPendenciaRecebida: handlePendenciaRecebida,
    onPendenciaAtualizada: handlePendenciaAtualizada
  })

  const refetchContador = useCallback(() => {
    queryClient.invalidateQueries(QUERY_KEY_PENDENCIAS_COUNT)
  }, [queryClient])

  return (
    <>
      <button
        onClick={() => setShowLista(true)}
        className="relative flex h-8.5 w-8.5 items-center justify-center rounded-full border-[0.5px] border-gray-300 bg-gray-50 hover:text-gray-600"
      >
        <Bell className="w-5 h-5" />
        {count > 0 && (
          <span className="absolute -top-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>

      {showLista && (
        <ListaPendencias
          onClose={() => setShowLista(false)}
          onPendenciaMarcadaLida={refetchContador}
        />
      )}
    </>
  )
}

